import React, { useEffect, useRef, useState } from "react";

/** Common Components */
import Buttons from "../../../../components/ui/button/Buttons";
import FormCreator from "../../../../components/forms/FormCreator";
import { addEditClientValuationFormConfig } from "./addEditClientValuation.formfields.config";
import { useLazyGetAllReportTemplateListQuery } from "../../../../app/services/reportTemplateAPI";
import { mapDropdownOptions } from "../../../../components/forms/libs/data/mapDropdownOptions";
import { useAddClientValuationMutation, useGetClientCopyValuationMutation, useLazyGetAllClientValuationListQuery } from "../../../../app/services/clientValuationAPI";
import ToastService from "../../../../services/toastService/ToastService";
import { decryptUrlData } from "../../../../services/CryptoService";
import { useParams } from "react-router-dom";
import PropTypes from "prop-types";

/** Configuration Files */

const AddEditClientValuation = (props) => {
  const clientRef = useRef(null);

  const { id } = useParams();
  const decryptedData = id ? decryptUrlData(id) : {};

  const { data } = decryptedData;

  const [clientValuationForm, setClientValuationForm] = useState(addEditClientValuationFormConfig);

  const [addClientValuation, {
    isLoading: isClientValuationAdding,
    isSuccess: isClientValuationAdded,
    data: clientValuationAddedData
  }] = useAddClientValuationMutation()

  const [getAllReportTemplateList, {
    isFetching: isAllReportTemplateFetching,
    isSuccess: isAllReportTemplateSuccess,
    data: AllReportTemplateData
  },] = useLazyGetAllReportTemplateListQuery();

  const [getClientCopyValuation, {
    isLoading: isGetClientCopyValuationLoading,
    isSuccess: isGetClientCopyValuationSuccess,
    data: clientCopyValuationData
  }] = useGetClientCopyValuationMutation();


  const [getAllClientValuationList, {
    isFetching: isAllClientValuationListFetching,
    isSuccess: isAllClientValuationListSuccess,
    data: AllClientValuationListData
  },] = useLazyGetAllClientValuationListQuery();

  const resetForm = () => {
    const form = { ...addEditClientValuationFormConfig };
    form.initialState = {
      ...addEditClientValuationFormConfig.initData,
      clientName: props.clientName,
      planName:props.selectPlan
    };
    setClientValuationForm(form);
  };

  useEffect(() => {
    getAllReportTemplateList();
    getAllClientValuationList()
    getClientCopyValuation(props.selectRow)
  }, [])

  const handleCloseClick = () => {
    resetForm();
    props?.onClose();
  };

    const handleAddClick = () => {
      const formData = clientRef.current?.getFormData?.();
    
      const planStartDate = new Date(formData.planYearBegin);
      const planEndDate = new Date(formData.planYearEnd);
    
      if (planEndDate < planStartDate) {
        ToastService.warning("Plan Year End cannot be before Plan Year Begin.");
        return;
      }
    
      const req = {
        valID: props.isEdit ? props.initData.valID : 0,
        planID: props.selectRow,
        planName: props.selectPlan,
        valName: formData.valName,
        planYearBegin: planStartDate,
        planYearEnd: planEndDate,
        reportTemplateID: formData.reportTemplateID.value,
        copyValID: formData.copyValID?.value ?? null,
        clientName: props.clientName
      };
    
      addClientValuation(req);
    };
    
  
  
  useEffect(() => {
    if (props.isEdit && props.initData) {
      const form = { ...clientValuationForm };
      form.initialState = {
        ...props.initData,
        clientName: props.clientName,
        planName:props.selectPlan
      }
      setClientValuationForm(form);
    } else {
      resetForm();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.isEdit, props.initData]);

  useEffect(() => {
    if (isGetClientCopyValuationSuccess && clientCopyValuationData) {
      mapDropdownOptions(
        addEditClientValuationFormConfig,
        "basicDetailSection",
        "copyValID",
        clientCopyValuationData,
        "copyValID",
        "valName"
      );
    }
  }, [isGetClientCopyValuationSuccess, clientCopyValuationData]);

  useEffect(() => {
    if (
      !isAllClientValuationListFetching &&
      isAllClientValuationListSuccess &&
      AllClientValuationListData
    ) {
      
    }
  }, [
    isAllClientValuationListFetching,
    isAllClientValuationListSuccess,
    AllClientValuationListData,
  ]);



  useEffect(() => {
    if (!isAllReportTemplateFetching && isAllReportTemplateSuccess && AllReportTemplateData) {
      const form = { ...clientValuationForm }
      mapDropdownOptions(
        form,
        'basicDetailSection',
        'reportTemplateID',
        AllReportTemplateData,
        'reportTemplateID',
        'reportTemplateName'
      )
      setClientValuationForm(form);
    }
  }, [isAllReportTemplateFetching, isAllReportTemplateSuccess, AllReportTemplateData]);


  useEffect(() => {
    if (isClientValuationAdded && clientValuationAddedData) {
      if (clientValuationAddedData?.errorMessage?.includes('exist')) {
        ToastService.warning(clientValuationAddedData.errorMessage);
      } else {
        ToastService.success(clientValuationAddedData.errorMessage);
        props.onSuccess?.();
      }
    }
  }, [isClientValuationAdded, clientValuationAddedData]);

  return (
    <>
      <div>
        <FormCreator ref={clientRef} config={clientValuationForm} />
      </div>
      <div className="form-button-group">
        <Buttons
          buttonText="Cancel"
          buttonTypeClassName="btn secondary-btn"
          onClick={handleCloseClick}
        />
        <Buttons
          buttonText={props.isEdit ? "Update" : "Add"}
          buttonTypeClassName="btn blue-btn w-full"
          onClick={handleAddClick}
          isLoading={false}
        />
      </div>
    </>
  );
};

AddEditClientValuation.propTypes = {
  isEdit: PropTypes.bool.isRequired,
  clientName: PropTypes.string.isRequired,
  selectPlan: PropTypes.string.isRequired,
  selectRow: PropTypes.number.isRequired,
  initData: PropTypes.shape({
    valID: PropTypes.number,
    valName: PropTypes.string,
    planYearBegin: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.instanceOf(Date)
    ]),
    planYearEnd: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.instanceOf(Date)
    ]),
    reportTemplateID: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.shape({
        value: PropTypes.number,
        label: PropTypes.string,
      })
    ]),
    copyValID: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.shape({
        value: PropTypes.number,
        label: PropTypes.string,
      })
    ]),
  }),
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func,
};

export default AddEditClientValuation;
